import React from 'react';
import { Fade } from 'react-awesome-reveal';

const PageHeader = ({ title, breadcrumb }) => {
  return (
    <Fade triggerOnce>
      <div className="container-fluid page-header py-6">
      <div className="container text-center pt-5 pb-3">
        <h1 className="display-4 text-white animated slideInDown mb-3">{title}</h1>
        <nav aria-label="breadcrumb animated slideInDown">
          <ol className="breadcrumb justify-content-center mb-0">
            {breadcrumb.map((item, index) => (
              <li key={index} className={`breadcrumb-item ${item.active ? 'text-primary active' : ''}`}>
                {item.active ? (
                  <span aria-current="page">{item.label}</span>
                ) : (
                  <a className="text-white" href={item.href}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      </div>
    </Fade>
  );
};

export default PageHeader;






